import { QueryDispatcherAbort } from "../../shared/domain/QueryDispatcher";

export class ServicesPricesFiscalPositionQuery {
  ctr;
  constructor(
    private readonly dispatcher: QueryDispatcherAbort,
    private readonly frontend
  ) {
    this.ctr = undefined;
  }

 async run(promotional_code?: String, kind?): Promise<{ [key: string]: string; }> {
    if(this.ctr){
      this.ctr.abort('relaunched')
    }
    let args = {}
    if(promotional_code){
      args = {promotional_code:promotional_code}
    }
    if(kind){
      switch (kind) {
        case 'invoices':
          args['kind'] = 'documents';
          break;
        default:
          args['kind'] = kind;
          break;
      }    
    }
    const res = await this.dispatcher.dispatch('services_prices.fiscal_position', args)
    this.ctr = res.controller
    if(kind){   
      this.frontend.services[kind] = res.promise
    }
    
    if (promotional_code != '' && promotional_code != undefined && res.promise[0]['is_valid_code'] == false) {
      this.frontend.is_valid_promotional_code(false, kind)
    } else {
      this.frontend.is_valid_promotional_code(true, kind)
    }
    
    return res.promise
  }
}